var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-main-content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c("div", { staticClass: "form-box" }, [
            _c("div", { staticClass: "form-title-wrap" }, [
              _c(
                "div",
                {
                  staticClass: "d-flex align-items-center justify-content-end",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "theme-btn theme-btn-small",
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.createCruise },
                    },
                    [
                      _c("i", { staticClass: "la la-plus mr-1" }),
                      _vm._v(
                        "\n                  Cruise Yarat\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-content pb-2" }, [
              _c("h3", { staticClass: "title" }, [_vm._v("Cruises")]),
              _vm._v(" "),
              _vm.cruiseList != null
                ? _c("p", { staticClass: "font-size-14" }, [
                    _vm._v(
                      _vm._s(_vm.cruiseList.length) + " cruise listeleniyor"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "table-form table-responsive" }, [
                _c("table", { staticClass: "table" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.cruiseList, function (cruise) {
                      return _c("tr", [
                        _c("th", { attrs: { scope: "row" } }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.basePath + "/cruises/" + cruise.id,
                              },
                            },
                            [_vm._v("#" + _vm._s(cruise.id))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(cruise.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(cruise.description))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            { staticClass: "table-content" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "theme-btn theme-btn-small",
                                  attrs: {
                                    tag: "a",
                                    to: "/cruises/" + cruise.id,
                                    title: "",
                                    "data-original-title": "Edit",
                                    "active-class": "active",
                                    exact: "",
                                  },
                                },
                                [_c("i", { staticClass: "la la-edit" })]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Id")]),
        _vm._v(" "),
        _c("th", [_vm._v("Adı")]),
        _vm._v(" "),
        _c("th", [_vm._v("Açıklama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Aksiyon")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }